// @ts-strict-ignore
import { addExperimentGroupToTargeting } from '@platforms/shared';
import {
	BaseServiceSetup,
	context,
	defineExperiment,
	Experiment,
	getExperiment,
	utils,
} from '@wikia/ad-engine';

type RunningExperimentType = Experiment | null | undefined;

const logGroup = 'UcpMobilePersistentAdhesionExperiment';

export class UcpMobilePersistentAdhesionExperiment extends BaseServiceSetup {
	private pathfinderExperimentVariantNames = {
		control: 'mobile-persistent-adhesion-control-v2',
		active: 'mobile-persistent-adhesion-active-v2',
	};

	private pathfinderExperimentVariants = [
		defineExperiment({
			name: this.pathfinderExperimentVariantNames.control,
			buckets: ['38', '44', '51'],
		}),
		defineExperiment({
			name: this.pathfinderExperimentVariantNames.active,
			buckets: ['17', '18', '25'],
		}),
	];

	call(): void {
		this.configure();
	}

	private pathfinderActiveExperimentVariant: RunningExperimentType = getExperiment(
		this.pathfinderExperimentVariants,
	);

	private configure() {
		if (this.isExperimentEnabled() && this.pathfinderActiveExperimentVariant?.name) {
			switch (this.pathfinderActiveExperimentVariant.name) {
				case this.pathfinderExperimentVariantNames.active:
					utils.logger(logGroup, 'Active group');
					context.set('experiments.persistentAdhesionExperiment', true);
					context.set('hideAdhesionCloseButton', true);
					addExperimentGroupToTargeting(this.pathfinderExperimentVariantNames.active);
					break;
				case this.pathfinderExperimentVariantNames.control:
					utils.logger(logGroup, 'Control group');
					context.set('experiments.persistentAdhesionExperiment', false);
					context.set('hideAdhesionCloseButton', false);
					addExperimentGroupToTargeting(this.pathfinderExperimentVariantNames.control);
					break;
			}
		} else {
			utils.logger(logGroup, 'Experiment disabled');
			context.set('experiments.persistentAdhesionExperiment', false);
			return;
		}
	}

	private isExperimentEnabled(): boolean {
		return (
			this.instantConfig.get('icExperiments', []).includes('mobilePersistentAdhesionExperiment') &&
			!this.hasFeaturedVideo()
		);
	}

	private hasFeaturedVideo(): boolean {
		return document.body.classList.contains('has-featured-video');
	}
}
